import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Avatar,
  Divider
} from '@mui/material';
import {
  CheckCircle as ApprovedIcon,
  Cancel as RejectedIcon,
  Edit as EditIcon,
  Add as CreateIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

const getActionIcon = (action) => {
  const icons = {
    created: <CreateIcon />,
    updated: <EditIcon />,
    approved: <ApprovedIcon />,
    rejected: <RejectedIcon />,
    deleted: <DeleteIcon />
  };
  return icons[action?.toLowerCase()] || <EditIcon />;
};

const getActionColor = (action) => {
  const colors = {
    created: 'info',
    updated: 'warning',
    approved: 'success',
    rejected: 'error',
    deleted: 'error'
  };
  return colors[action?.toLowerCase()] || 'default';
};

const AuditTimeline = ({ events = [], emptyMessage = 'No audit history available' }) => {
  if (!events || events.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      {events.map((event, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Paper elevation={1} sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Avatar
                sx={{ width: 32, height: 32, fontSize: '0.875rem', bgcolor: `${getActionColor(event.action)}.main` }}
                src={event.user?.avatar}
              >
                {event.user?.name?.charAt(0) || event.userName?.charAt(0) || 'U'}
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {event.user?.name || event.userName || 'Unknown User'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {new Date(event.timestamp || event.createdAt).toLocaleString()}
                </Typography>
              </Box>
              <Chip
                label={event.action}
                size="small"
                color={getActionColor(event.action)}
                icon={getActionIcon(event.action)}
                sx={{ height: 24, fontSize: '0.75rem' }}
              />
            </Box>
            {event.description && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {event.description}
              </Typography>
            )}
            {event.changes && (
              <Box sx={{ mt: 1, p: 1, backgroundColor: 'grey.50', borderRadius: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  Changes: {event.changes}
                </Typography>
              </Box>
            )}
          </Paper>
          {index < events.length - 1 && <Divider sx={{ my: 1 }} />}
        </Box>
      ))}
    </Box>
  );
};

export default AuditTimeline;
